import { Link } from "react-router-dom";
import { MapPin, Users, Star } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export default function PropertyCard({ p, size = "md" }) {
  const priceFmt = new Intl.NumberFormat("en-IN").format(p.price_per_night);
  return (
    <Link
      to={`/stays/${p.id}`}
      className="group block rounded-3xl overflow-hidden bg-white border border-[#0E2E24]/10 hover-lift"
      data-testid={`property-card-${p.id}`}
    >
      <div className={`relative overflow-hidden ${size === "lg" ? "aspect-[4/3]" : "aspect-[4/3]"}`}>
        <img
          src={p.images?.[0]}
          alt={p.name}
          className="img-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
          loading="lazy"
        />
        {p.managed && (
          <Badge className="absolute top-4 left-4 bg-[#F4A930] hover:bg-[#F4A930] text-[#0E2E24] font-sora text-[10px] tracking-widest uppercase rounded-full px-3 py-1" data-testid={`managed-badge-${p.id}`}>
            Managed by Appy
          </Badge>
        )}
        <div className="absolute bottom-4 right-4 bg-[#0E2E24] text-[#FAFAF8] rounded-full px-3 py-1.5 flex items-center gap-1 text-xs font-sora">
          <Star size={12} className="fill-[#F4A930] text-[#F4A930]" />
          {p.rating?.toFixed(2)}
        </div>
      </div>

      <div className="p-6">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h3 className="font-display text-xl md:text-2xl text-[#0E2E24] leading-tight group-hover:text-[#1F5A43] transition-colors">
              {p.name}
            </h3>
            <div className="mt-1.5 flex items-center gap-1 text-[#111111]/60 text-sm">
              <MapPin size={13} /> {p.location}
            </div>
          </div>
          <div className="text-right shrink-0">
            <div className="font-sora text-[#0E2E24] text-lg font-semibold">₹{priceFmt}</div>
            <div className="text-[11px] text-[#111111]/50 font-sora tracking-wide">/ night</div>
          </div>
        </div>

        <div className="mt-5 flex items-center justify-between">
          <div className="flex items-center gap-1.5 text-[#1F5A43] text-sm font-sora">
            <Users size={14} /> Up to {p.capacity}
          </div>
          <div className="flex flex-wrap gap-1.5">
            {(p.tags || []).slice(0, 2).map((t) => (
              <span key={t} className="text-[11px] px-2.5 py-1 rounded-full bg-[#E8F2EC]/30 text-[#0E2E24] font-sora">
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>
    </Link>
  );
}
